module.exports = __webpack_public_path__ + "static/img/13.f89c107.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/13.png
// module id = qZ1S
// module chunks = 0